import { Component, HostListener, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DownloadVersionDialogComponent } from '@components/download-version-dialog/download-version-dialog.component';
import { VesselMenuPrintDialogComponent } from '@components/vessel-menu-print-dialog/vessel-menu-print-dialog.component';
import { VesselDataService } from '@service/vessel-data.service';
import { Vessel } from 'icreate/common/models/vessel';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'app-vessel-project-buttons',
    templateUrl: './vessel-project-buttons.component.html',
    styleUrls: ['./vessel-project-buttons.component.css'],
    standalone: false,
})
export class VesselProjectButtonsComponent {
    @Input() vessel: Vessel;
    @Input() buttonsAreDisabled: boolean;
    @Input() hasPreviousVersion: boolean;
    @Input() shipyardiApi: string;

    showVesselDataOption: boolean = false;

    constructor(
        private router: Router,
        private vesselDataService: VesselDataService,
        private dialog: MatDialog
    ) {}

    @HostListener('document:click', ['$event'])
    clickOut(event: MouseEvent) {
        if (this.showVesselDataOption) this.showVesselDataOption = false;
    }

    openEditorPage() {
        if (this.buttonsAreDisabled) return;
        this.router.navigateByUrl(`editor/${this.vessel.id}`);
    }

    openChannelsPage() {
        if (this.buttonsAreDisabled) return;
        this.router.navigateByUrl(`channels/${this.vessel.shipyardId}/${this.vessel.id}`);
    }

    openOpsSetting() {
        if (this.buttonsAreDisabled) return;
        this.router.navigateByUrl(`home/${this.vessel.id}/settings`);
    }

    openGraphsPage() {
        if (this.buttonsAreDisabled) return;
        this.router.navigateByUrl(`graphs/${this.vessel.id}`);
    }

    openSpecificationPage() {
        if (this.buttonsAreDisabled) return;
        this.router.navigateByUrl(`home/${this.vessel.id}/specification`);
    }

    openMainPrintDialog() {
        const dialogRef = this.dialog.open(VesselMenuPrintDialogComponent, {
            data: {
                vessel: this.vessel,
                iAPIVesselId: this.vessel.iAPIVesselId,
                shipyardId: this.vessel.shipyardId,
            },
        });
    }

    async downloadData() {
        let version = this.vessel.projectVersion;
        if (this.hasPreviousVersion) {
            const dialogRef = this.dialog.open(DownloadVersionDialogComponent, {
                data: { vessel: this.vessel, shipyardIApi: this.shipyardiApi },
                width: '474px',
            });

            const selectedVersion = await lastValueFrom(dialogRef.afterClosed());
            if (!selectedVersion) return;
            version = selectedVersion;
        }

        try {
            const isCurrentVersion = version == this.vessel.projectVersion;
            const vesselData = await this.vesselDataService.downloadVesselData(
                this.shipyardiApi,
                this.vessel.iAPIVesselId,
                version,
                isCurrentVersion,
                this.vessel.id
            );
            const filename = `vessel-${this.vessel.number}-${version}.zip`;
            this.saveBlobAsFile(vesselData, filename);
        } catch (err) {
            console.log(err);
        }
    }

    private saveBlobAsFile(blob: Blob, filename: string): void {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    }
}
